// Build-time defaults; runtime can override via window.__SCHOOL_UI_CONFIG__
// (injected by the nginx container's /config.json fetch in Phase 4).

interface RuntimeConfig {
  oidcClientId: string;
  oidcScopes: string;
  novaOsBaseUrl: string;
}

declare global {
  interface Window {
    __SCHOOL_UI_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const DEFAULTS: RuntimeConfig = {
  oidcClientId: "school-ui",
  // offline_access makes Nova OS include a rotating refresh_token in the
  // code exchange (cf. nova-os oidc.go hasScope(ac.Scope, "offline_access"))
  // so the SPA can renew the 1h access token without bouncing the user
  // through /oauth/authorize mid-session.
  oidcScopes: "openid email profile offline_access",
  // Empty string means "same origin" — gateway proxies /oauth/* to Nova OS.
  // Override only when the SPA is hosted on a different origin than the gateway.
  novaOsBaseUrl: "",
};

export const config: RuntimeConfig = {
  ...DEFAULTS,
  ...(typeof window !== "undefined" ? window.__SCHOOL_UI_CONFIG__ ?? {} : {}),
};

export const TOKEN_STORAGE_KEY = "nova_token";
export const REFRESH_TOKEN_STORAGE_KEY = "nova_refresh_token";
export const POST_LOGIN_REDIRECT_KEY = "nova_post_login_redirect";
export const PKCE_VERIFIER_KEY = "nova_pkce_verifier";
export const PKCE_STATE_KEY = "nova_pkce_state";
